module.exports = __webpack_public_path__ + "static/media/news1.f13b05af.png";